import {
  LIST_EXAMINATION_RESULT_RECAP_REQUEST,
  LIST_EXAMINATION_RESULT_RECAP_SUCCESS,
  LIST_EXAMINATION_RESULT_RECAP_FAIL,
  EXPORT_EXAMINATION_RESULT_RECAP_REQUEST,
  EXPORT_EXAMINATION_RESULT_RECAP_SUCCESS,
  EXPORT_EXAMINATION_RESULT_RECAP_FAIL,
  DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_REQUEST,
  DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_SUCCESS,
  DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_FAIL
} from '../../constants/result-recaps'

const initialState = {
  loading: false,
  resultRecaps: [],
  pageable: {},
  loadingDownload: false,
  error: null,
  exportLoading: false
}

const resultRecapReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EXAMINATION_RESULT_RECAP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case LIST_EXAMINATION_RESULT_RECAP_SUCCESS:
      return {
        ...state,
        loading: false,
        resultRecaps: action.payload,
        pageable: action?.pageable,
        error: null
      }
    case LIST_EXAMINATION_RESULT_RECAP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        resultRecaps: action?.dummy
      }
    case EXPORT_EXAMINATION_RESULT_RECAP_REQUEST:
      return {
        ...state,
        exportLoading: true,
        error: null
      }
    case EXPORT_EXAMINATION_RESULT_RECAP_SUCCESS:
      return {
        ...state,
        exportLoading: false,
        resultRecaps: action.payload,
        error: null
      }
    case EXPORT_EXAMINATION_RESULT_RECAP_FAIL:
      return {
        ...state,
        exportLoading: false,
        error: action.payload
      }
    case DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_REQUEST:
      return {
        ...state,
        loadingDownload: true,
        error: null
      }
    case DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_SUCCESS:
      return {
        ...state,
        loadingDownload: false,
        error: null
      }
    case DOWNLOAD_FILE_EXAMINATION_RESULT_RECAP_FAIL:
      return {
        ...state,
        loadingDownload: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default resultRecapReducer
